/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC,useState,useEffect} from 'react'
import {Routes, Route, BrowserRouter, Navigate, useNavigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import axios from 'axios';
import liff from '@line/liff';
import {ReactSession } from 'react-client-session';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import {db, storage} from '../pages/firebase';
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const [name, setName] = useState("");
  const [userLineID, setUserLineID] = useState("");
    const [pictureUrl, setPictureUrl] = useState("");
    const [userclub, setUserclub] = useState("");
    const [avsliffid, setavsliffid] = useState("");
    const [datasetup, setdatasetup] = useState('');

    async function checksetup() {
        let setupweb = window.sessionStorage.getItem('setupweb');
        let liffid = window.sessionStorage.getItem('liffid');
        let linedata = window.sessionStorage.getItem('linedata');
        if (setupweb && liffid && linedata) {
          console.log("jjj");

        }else{
        fetchLiff()
        }
    }


 async function fetchLiff() {
             let club = (new URLSearchParams(window.location.search)).get("Club_Code");
             console.log("club",club);

             let clubs= ""+club;
             if (clubs) {

              window.sessionStorage.setItem("Club_Code",clubs);
              const clubid = window.sessionStorage.getItem("Club_Code");
              let clubidweb= ""+clubid;
              if (clubidweb) {

                const storageRefdatasetup = await ref_storage(storage, 'config_file/setup_web.json');
                getDownloadURL(storageRefdatasetup).then((urldatasetup) => {
                const resdatasetup = axios.get(urldatasetup)
                  .then(resdatasetup=> {
                    console.log("gggggggfggg");

                    setdatasetup(resdatasetup.data)
                    window.sessionStorage.setItem("setupweb",JSON.stringify(resdatasetup.data));
                  })
                  .catch(err=> console.log(err))


              //get api
              fetch(urldatasetup, {
                method: 'GET',
                redirect: 'follow'
              })
            .then(response => response.text())
            .then(result => {
              console.log("result",result);


            })
            .catch(error => console.log('error', error));
                      });


              const storageRefdataconnection = ref_storage(storage, 'config_file/connection_web.json');
              getDownloadURL(storageRefdataconnection).then((urldataconnection) => {
              const resdataconnection =  axios.get(urldataconnection)
                .then(resdataconnection=> {
                  setdatasetup(resdataconnection.data)
                  window.sessionStorage.setItem("connection",JSON.stringify(resdataconnection.data));
                })
                .catch(err=> console.log(err))
            });


              }
             }else{
              //  console.log("cunnnon");

             }


           //const user = window.sessionStorage.getItem("Customerdata");
           const clubid = window.sessionStorage.getItem("Club_Code");
           let clubidweb= ""+clubid;
          const liffIdline = getliffidclub(clubidweb);

          const liffidweb = window.sessionStorage.getItem("liffid");
          let liffweb= ""+liffidweb;
          console.log(liffweb);
          const setstylywebavs =setstylesweb(clubidweb);
          const cus_data = fetchchecklogin();
        //  const cus_data =  window.sessionStorage.getItem("Customerdata");
          if (liffweb) {
              await liff.init({ liffId: liffweb }) //console.log(res)=idlift

              console.log("isInClient",liff.isInClient());
              console.log("liff.getOS()",liff.getOS());


              if (liff.isLoggedIn()) {
                let getProfile =  await liff.getProfile();
                console.log(getProfile);
                setName(getProfile.displayName);
                setUserLineID(getProfile.userId);
                //  console.log(getProfile);
                window.sessionStorage.setItem("linedata",getProfile.userId);

              }else{
                liff.login();
              }

          }else{
            console.log("liff nonnn");

          }





 }

         async function fetchchecklogin() {
           const currentUser = "true"
             if (userLineID) {

               const customerbc ="v";

             }


         }
         /// avs
         function setDatacustomer() {
           let obj ={name:'john',age:"12",email: "bos.yura@gmail.com",Club_Code:"Club3",backgroundColor:"red"}
            return  obj;
         }
         function getDatacustomer() {
           let obj ={name:name,age:"12",email: "bos.yura@gmail.com",Club_Code:"Club3",backgroundColor:"red",userId:userLineID}
            return  obj;
         }
         async  function getliffidclub(club: any) {
            const avsliffid ="";
            let setupweb = window.sessionStorage.getItem('setupweb');
            let setupwebconvert= ""+setupweb;
            const obj = JSON.parse(setupwebconvert);
              Object.entries(obj).map((value: any[]) => {
                  if (club==value[1]['club_code']) {
                    let liff_url = value[1]['liff_url'];
                    let result1 = liff_url.substr(21);

                    window.sessionStorage.setItem("setupwebdefault",JSON.stringify(value[1]));
                    const   avsliffid = result1;
                      window.sessionStorage.setItem("liffid",result1);


                  }
                })
                return avsliffid;

         }
         function setstylesweb(club: any) {
            let obj ={backgroundColor:'#331f9a',color:'#000'}
            return  obj;
         }
         function useAuthweb() {
            let obj ="dddd"
            return  obj;
         }






useEffect(() => {
  // checksetup()

  /* setTimeout(() => {
       checksetup()
   }, 3000);
  const getCheckData = async () => {
    await checksetup()

    // await updatadata()
  };
  getCheckData();*/
}, [])
//  fetchchecklogin();
//  const {currentUser} = useAuth()

// console.log(userLineID);

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
            {

            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/editeMember' />} />
              <Route index element={<Navigate to='/homepage' />} />
              <Route index element={<Navigate to='/contact' />} />
              <Route index element={<Navigate to='/card' />} />
            </>
          }
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
